import React from 'react';

import { Error } from '@consumer-frontend/components';
import { Container } from '@consumer-frontend/shared-ui';

export type ErrorPagePropsT = {
  message: string;
};
export type ErrorPageT = React.FC<ErrorPagePropsT>;

export const ErrorPage: ErrorPageT = ({ message }) => (
  <Container className="cnu-error p-5 d-flex align-items-center justify-content-center flex-column rounded" hasBoxShadow>
    <Error displaySupportText message={message} />
  </Container>
);
